// Type of record:
// 1 = "S"ale
// 2 = "C"redit memo (aka Return)
// 3 = price "A"djustment (aka miscellaneous credit/debit)
// 4 = "P"ending sale
// 5 = ser"V"ice order.  See ApplicationFlagName.

export const SALES_ORDER_TYPE_CODES = [
    {
        label: 'Sale',
        value: 1
    }, {
        label: 'Return',
        value: 2
    }, {
        label: 'Adjustment',
        value: 3
    }, {
        label: 'Pending Sale',
        value: 4
    }, {
        label: 'Service Order',
        value: 5
    }
];
